import Raven from 'raven-js';
import { Component } from 'react';
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    return Raven.captureException(error, {
      tags: {
        errorBoundaryName: this.props.boundaryName
      }
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    const errorComponent = this.props.errorComponent ? this.props.errorComponent : null;
    if (hasError) {
      return errorComponent;
    }
    return this.props.children;
  }
}